import React from 'react';
import { TemplateForService } from 'pages';

interface Props {
    children: React.ReactNode;
    title?: string;
    serviceIdx: number;
    serviceType: string;
}

function Template({ children, serviceIdx, serviceType, title }: Props): React.ReactElement {
    return (
        <TemplateForService isBackBtn={true} title={title} serviceType={serviceType} serviceIdx={serviceIdx}>
            {children}
        </TemplateForService>
    );
}

export default Template;
